// @ts-nocheck
import { css } from "@emotion/core";
import styled from "@emotion/styled";
import DoneCheckbox from "../DoneCheckbox";
import { Button, Card, Row, SubHeading, Text } from "nectar-ui";
import { NectarTheme } from "@nectarTypes";
import { shadows } from "src/style";

export const FilterButtonsWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacings.sm};

    ${theme.breakpoints.sm} {
      flex-direction: row;
    }
  `}
`;

type FilterOptionsWrapperProps = { isFilterOpen: boolean; align: string } & NectarTheme;

export const FilterOptionsWrapper = styled.div<FilterOptionsWrapperProps>`
  ${({ theme, isFilterOpen, align }) => css`
    position: absolute;
    box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1);
    display: ${isFilterOpen ? "block" : "none"};
    top: ${theme.spacings.xl};
    ${[align]}: 0;
    z-index: 9999;
    width: fit-content;
    background-color: white;
    max-height: 420px;
    width: 250px;
    padding: ${theme.spacings.md} 0 ${theme.spacings.xs};
    ${shadows.XS};
    border-radius: ${theme.borderRadius.md};
  `}
`;

export const ActionsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-right: ${({ theme }) => theme.spacings.md};
  gap: ${({ theme }) => theme.spacings.xxs};
`;

export const StyledActionButton = styled(Button)`
  ${({ theme }) => `
    padding: 10px;
    margin-top: 16px;
    border-radius: ${theme.spacings.xs};
  `}
`;

export const ErrorText = styled(Text)`
  margin-left: ${({ theme }) => theme.spacings.md};
`;

export const CheckboxesWrapper = styled.div<NectarTheme & { hasTextSection: boolean }>`
  ${({ theme, hasTextSection }) => `
    display: block;
    margin: 0 ${theme.spacings.md};
    max-height: ${hasTextSection ? "299px" : "326px"};
    overflow: scroll;

    & div {
      margin: ${theme.spacings.xs} 0;
    }

    ::-webkit-scrollbar {
      width: ${theme.spacings.md};
    }

    ::-webkit-scrollbar-track {
      background: ${theme.colors.white};
    }

    ::-webkit-scrollbar-thumb {
      background: ${theme.colors.gray300};
      border: ${theme.spacings.xxs} solid transparent;
      border-radius: 14px;
      background-clip: content-box;
    }

    ::-webkit-scrollbar-thumb:hover {
      background: ${theme.colors.secondary};
      border: ${theme.spacings.xxs} solid transparent;
      border-radius: 14px;
      background-clip: content-box;
    }
  `}
`;

export const CustomerFilterContainer = styled.div`
  ${({ _theme }) => css``}
`;

export const DatePickerCard = styled(Card)`
  width: 190px;
  position: absolute;
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 6px 0 6px 0;
  z-index: 5;
`;

export const DatePickerContainer = styled.div`
  ${({ theme }) => css`
    left: -20px;
    padding: ${theme.spacings.sm} ${theme.spacings.md};
  `}
`;

export const DatePickerRow = styled(Row)`
  ${({ _theme }) => css`
    margin: 0;
  `}
`;

export const DatePickerButton = styled(Button)`
  ${({ theme }) => css`
    padding: ${theme.spacings.xs};
  `}
`;

export const DatePickerActionsContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    justify-content: space-evenly;
    padding-top: 5px;
    border-top: 1px solid ${theme.colors.gray300};
    padding: ${theme.spacings.ms};
  `}
`;

export const DatePickerErrorText = styled(Text)`
  ${({ _theme }) => css`
    margin: 0px;
  `}
`;

export const StyledText = styled(Text)`
  ${({ theme }) => `
    margin-left: ${theme.spacings.md};
    margin-bottom: 0 !important;
  `}
`;

export const TagContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row;
    gap: ${theme.spacings.xs};
    margin-top: ${theme.spacings.xs};
    flex-wrap: wrap;
  `}
`;

export const StyledSubHeading = styled(SubHeading)`
  letter-spacing: 0 !important;
  font-weight: 500 !important;
`;

export const StyledDoneCheckbox = styled(DoneCheckbox)<NectarTheme & { block: boolean }>`
  ${({ theme }) => css`
    & > svg {
      margin: ${theme.spacings.xs};
    }

    & > div {
      margin-left: ${theme.spacings.xxs} !important;
    }
  `};
`;
